<template>
  <div class="floating-sidebar fixed right-4 md:right-6 bottom-[10vh] z-40 flex flex-col gap-3 items-center">
    <!-- 机构入驻按钮 -->
    <a href="javascript:;" class="sidebar-entry-btn group relative flex flex-col items-center justify-center w-[68px] h-[72px] bg-white dark:bg-slate-800 rounded-2xl shadow-lg dark:shadow-none border border-slate-100 dark:border-slate-700 no-underline transition-all duration-300 cursor-pointer hover:-translate-y-1 hover:shadow-xl" @click="handleSettle">
      <div class="text-brand-500 mb-1 p-1.5 bg-brand-500/[0.06] rounded-lg transition-all duration-300 group-hover:bg-brand-500 group-hover:text-white">
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M3 21h18M3 7v1a3 3 0 0 0 6 0V7m0 1a3 3 0 0 0 6 0V7m0 1a3 3 0 0 0 6 0V7H3l2-4h14l2 4M5 21V10.87M19 21V10.87" />
        </svg>
      </div>
      <span class="text-[11px] font-bold text-brand-600 dark:text-brand-400">机构入驻</span>
      <!-- Tooltip -->
      <div class="absolute right-full top-1/2 -translate-y-1/2 translate-x-2 mr-4 opacity-0 invisible transition-all duration-300 pointer-events-none group-hover:opacity-100 group-hover:visible group-hover:translate-x-0">
        <div class="bg-slate-900 dark:bg-white text-white dark:text-slate-900 text-xs font-bold py-2.5 px-4 rounded-xl whitespace-nowrap shadow-[0_8px_24px_rgba(0,0,0,0.2)] relative">
          我是机构，立即入驻
          <div class="absolute -right-1 top-1/2 -translate-y-1/2 rotate-45 w-2 h-2 bg-slate-900 dark:bg-white"></div>
        </div>
      </div>
    </a>

    <!-- 主功能组 -->
    <div class="bg-white dark:bg-slate-800 rounded-2xl shadow-lg dark:shadow-none border border-slate-100 dark:border-slate-700 w-[68px] flex flex-col overflow-visible">
      <!-- 微信咨询 -->
      <div class="sidebar-item group relative py-3.5 flex flex-col items-center justify-center cursor-pointer transition-colors duration-300 text-slate-600 dark:text-slate-400 rounded-t-2xl hover:bg-slate-50 dark:hover:bg-slate-700">
        <svg class="transition-colors duration-300 group-hover:text-green-500" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
        </svg>
        <span class="text-[10px] text-slate-500 font-medium mt-0.5">微信咨询</span>
        <!-- 弹窗 -->
        <div class="sidebar-popover absolute right-full top-0 mr-4 opacity-0 invisible transition-all duration-300 translate-x-2 z-50 pointer-events-none group-hover:opacity-100 group-hover:visible group-hover:translate-x-0">
          <div class="bg-white dark:bg-slate-800 rounded-2xl shadow-[0_8px_32px_rgba(0,0,0,0.12)] border border-slate-100 dark:border-slate-700 relative p-4 flex flex-col items-center gap-2 w-40">
            <div class="w-32 h-32 bg-slate-50 rounded-xl border border-slate-100 p-1 flex items-center justify-center overflow-hidden">
              <img v-if="consultQrcodeUrl" :src="consultQrcodeUrl" alt="微信二维码" class="w-full h-full object-contain" />
              <svg v-else width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" stroke-width="1">
                <rect x="3" y="3" width="7" height="7" /><rect x="14" y="3" width="7" height="7" />
                <rect x="3" y="14" width="7" height="7" /><rect x="14" y="14" width="3" height="3" />
              </svg>
            </div>
            <p class="text-xs text-slate-500 dark:text-slate-400 text-center leading-relaxed">
              扫码添加专属顾问<br />
              <span class="text-brand-500 font-bold">1对1在线解答</span>
            </p>
            <div class="absolute -right-1.5 top-6 w-3 h-3 bg-white dark:bg-slate-800 border-t border-r border-slate-100 dark:border-slate-700 rotate-45"></div>
          </div>
        </div>
      </div>

      <!-- 电话咨询 -->
      <div class="sidebar-item relative py-3.5 flex flex-col items-center justify-center cursor-pointer transition-colors duration-300 text-slate-600 dark:text-slate-400 border-t border-slate-100 dark:border-slate-700 hover:bg-slate-50 dark:hover:bg-slate-700" @click.stop="showPhonePopover = !showPhonePopover">
        <svg :class="{'text-blue-500': showPhonePopover}" class="transition-colors duration-300" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
        </svg>
        <span class="text-[10px] text-slate-500 font-medium mt-0.5">电话咨询</span>
        <!-- 弹窗 (click-based) -->
        <div v-if="showPhonePopover" class="phone-popover absolute right-full top-1/2 mr-2 z-50" style="transform: translateY(-50%);" @click.stop>
          <!-- 透明桥接区域 -->
          <div style="position:absolute;top:0;bottom:0;right:-20px;width:20px;"></div>
          <div class="bg-white dark:bg-slate-800 rounded-2xl shadow-[0_8px_32px_rgba(0,0,0,0.12)] border border-slate-100 dark:border-slate-700 relative w-64 overflow-hidden">
            <!-- 预约表单 -->
            <div class="p-5 pb-4">
              <template v-if="!phoneSuccess">
                <h4 class="text-base font-bold text-slate-800 mb-0.5">预约电话</h4>
                <p class="text-xs text-slate-400 mb-4">专家顾问将在24小时内向您致电</p>
                <input
                  v-model="phoneNumber"
                  type="tel"
                  maxlength="11"
                  placeholder="请填写您的手机号"
                  class="phone-input"
                  :class="{ 'phone-input--error': phoneError }"
                  @input="onPhoneInput"
                />
                <p v-if="phoneError" class="text-xs text-red-500 mt-1 mb-0">{{ phoneError }}</p>
                <button
                  class="phone-submit-btn"
                  :disabled="phoneLoading"
                  @click.stop="handleBookPhone"
                >
                  {{ phoneLoading ? '提交中...' : '立即预约' }}
                </button>
              </template>
              <template v-else>
                <div class="flex items-center justify-center gap-2 mb-2">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#22c55e" stroke-width="2.5"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>
                  <span class="text-base font-bold text-slate-800">预约成功</span>
                </div>
                <p class="text-xs text-slate-400 text-center">专家顾问将在24小时内向您致电</p>
              </template>
            </div>
            <!-- 咨询热线 -->
            <div class="border-t border-slate-100 px-5 py-3 flex items-center gap-3">
              <div class="w-9 h-9 rounded-full bg-brand-500/10 flex items-center justify-center flex-shrink-0">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="text-brand-500">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                </svg>
              </div>
              <div>
                <p class="text-[10px] text-slate-400 leading-none mb-1">咨询电话 10:00–21:00</p>
                <p class="text-base font-black text-slate-800 tracking-tight leading-none">400-628-2024</p>
              </div>
            </div>
            <div class="absolute -right-1.5 top-1/2 -translate-y-1/2 w-3 h-3 bg-white dark:bg-slate-800 border-t border-r border-slate-100 dark:border-slate-700 rotate-45"></div>
          </div>
        </div>
      </div>

      <!-- 限时礼包 -->
      <div v-if="giftList.length" class="sidebar-item group relative py-3.5 flex flex-col items-center justify-center cursor-pointer transition-colors duration-300 text-slate-600 dark:text-slate-400 border-t border-slate-100 dark:border-slate-700 rounded-b-2xl hover:bg-slate-50 dark:hover:bg-slate-700">
        <div class="relative">
        <svg class="transition-colors duration-300 group-hover:text-rose-500" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="20 12 20 22 4 22 4 12" />
            <rect x="2" y="7" width="20" height="5" />
            <line x1="12" y1="22" x2="12" y2="7" />
            <path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z" />
            <path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z" />
          </svg>
          <span class="absolute -top-0.5 -right-0.5 w-2 h-2 bg-red-500 rounded-full border-2 border-white dark:border-slate-800"></span>
        </div>
        <span class="text-[10px] text-slate-500 font-medium mt-0.5">限时礼包</span>
        <!-- 弹窗 -->
        <div class="sidebar-popover absolute right-full bottom-0 mr-4 opacity-0 invisible transition-all duration-300 translate-x-2 z-50 pointer-events-none group-hover:opacity-100 group-hover:visible group-hover:translate-x-0">
          <div class="bg-white dark:bg-slate-800 rounded-2xl shadow-[0_8px_32px_rgba(0,0,0,0.12)] border border-slate-100 dark:border-slate-700 relative w-72 overflow-hidden">
            <div class="bg-gradient-to-br from-rose-500 to-orange-500 p-4 text-center relative overflow-hidden">
              <div class="absolute -top-6 -right-6 w-20 h-20 bg-white/20 rounded-full blur-[20px]"></div>
              <h4 class="text-base font-bold text-white relative z-10">新人专享大礼包</h4>
              <p class="text-[10px] text-white/90 relative z-10">注册即享专属权益</p>
            </div>
            <div class="p-3 bg-white dark:bg-slate-800 flex flex-col gap-2.5">
              <div
                v-for="(item, index) in giftList"
                :key="index"
                class="relative border border-dashed rounded-xl py-2.5 px-3 overflow-hidden"
                :class="giftColors[index % giftColors.length].border + ' ' + giftColors[index % giftColors.length].bg"
              >
                <div class="absolute top-1/2 -translate-y-1/2 -left-2 w-4 h-4 bg-white dark:bg-slate-800 rounded-full"></div>
                <div class="absolute top-1/2 -translate-y-1/2 -right-2 w-4 h-4 bg-white dark:bg-slate-800 rounded-full"></div>
                <div class="flex flex-col">
                  <span class="text-[10px] opacity-80" :class="giftColors[index % giftColors.length].text">{{ item.title }}</span>
                  <div class="flex items-baseline" :class="giftColors[index % giftColors.length].text">
                    <span class="text-xl font-black tracking-tight">{{ item.instructions || '专属权益' }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="absolute -right-1.5 bottom-8 w-3 h-3 bg-white dark:bg-slate-800 border-t border-r border-slate-100 dark:border-slate-700 rotate-45"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- 回到顶部 -->
    <button
      class="w-10 h-10 rounded-full bg-white dark:bg-slate-800 border border-slate-100 dark:border-slate-700 text-slate-400 flex items-center justify-center shadow-md cursor-pointer transition-all duration-500 hover:bg-slate-900 hover:border-slate-900 hover:text-white"
      :class="showBackToTop ? 'opacity-100 translate-y-0 pointer-events-auto' : 'opacity-0 translate-y-4 pointer-events-none'"
      @click="scrollToTop"
    >
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <polyline points="18 15 12 9 6 15" />
      </svg>
    </button>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { consultationApplication, fastCreateOrganization } from "@saas/server-api/src/organization";
import { getEquity } from "@saas/server-api/src/settle-in";
import { vailPhone, getHourTimestamp } from "@saas/components/src/utils/utils";
import { getMoguoCdnUrl } from "../utils/assets";

export default {
  name: "FloatingSidebar",
  data() {
    return {
      showBackToTop: false,
      phoneNumber: "",
      showPhonePopover: false,
      phoneLoading: false,
      phoneSuccess: false,
      phoneError: "",
      time: 0,
      giftList: [],
      giftColors: [
        { border: "border-rose-200", bg: "bg-rose-50", text: "text-rose-500" },
        { border: "border-orange-200", bg: "bg-orange-50", text: "text-orange-500" },
        { border: "border-blue-200", bg: "bg-blue-50", text: "text-blue-500" },
      ],
    };
  },
  computed: {
    ...mapGetters(["isAuthenticated", "user"]),
    isSettle() {
      return this.user && this.user.org_id;
    },
    consultQrcodeUrl() {
      return getMoguoCdnUrl("/cdn/static/images/kehu_zixun_qrcode.png") + "?t=" + this.time;
    },
  },
  mounted() {
    this.time = getHourTimestamp();
    window.addEventListener("scroll", this.handleScroll);
    document.addEventListener("click", this.handleClickOutside);
    this.fetchEquity();
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
    document.removeEventListener("click", this.handleClickOutside);
  },
  methods: {
    handleScroll() {
      this.showBackToTop = window.scrollY > 400;
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    handleClickOutside() {
      this.showPhonePopover = false;
    },
    onPhoneInput() {
      if (this.phoneError) {
        this.phoneError = "";
      }
    },
    // 机构入驻 — 与 ConsultEntry.handleSettle 逻辑一致
    handleSettle() {
      if (this.isAuthenticated) {
        if (this.isSettle) {
          window.open(process.env.VUE_APP_ADMIN_URL, "_blank");
        } else {
          fastCreateOrganization()
            .then((res) => {
              if (res.code === 1) {
                window.open(process.env.VUE_APP_ADMIN_URL, "_blank");
              } else {
                this.$message.error(res.message);
              }
            })
            .catch(() => {
              this.$message.error("机构创建失败，请稍后重试");
            });
        }
      } else {
        this.$loginDialog({ isShowEquity: true });
      }
    },
    // 预约电话 — 与 ConsultEntry.submitPhone 逻辑一致
    handleBookPhone() {
      if (!this.phoneNumber || !vailPhone(this.phoneNumber)) {
        this.phoneError = "请输入正确的手机号";
        return;
      }
      if (this.phoneLoading || this.phoneSuccess) return;
      this.phoneError = "";
      this.phoneLoading = true;
      consultationApplication({ mobile: this.phoneNumber })
        .then((res) => {
          if (res.code === 1) {
            this.phoneSuccess = true;
          } else {
            this.phoneError = res.message || "预约失败，请稍后重试";
          }
          this.phoneLoading = false;
        })
        .catch(() => {
          this.phoneError = "网络异常，请稍后重试";
          this.phoneLoading = false;
        });
    },
    // 获取权益列表 — 与 ConsultEntry.getEquity 逻辑一致
    fetchEquity() {
      getEquity()
        .then((res) => {
          if (res.code === 1) {
            this.giftList = res.data?.equity_list || [];
          }
        })
        .catch(() => {
          // 静默失败
        });
    },
  },
};
</script>

<style scoped>
.sidebar-entry-btn,
.sidebar-item,
button {
  cursor: pointer;
}

.phone-input {
  width: 100%;
  height: 40px;
  padding: 0 16px;
  font-size: 14px;
  color: #334155;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 9999px;
  outline: none;
  transition: all 0.3s;
  box-sizing: border-box;
}
.phone-input:focus {
  border-color: #40aa84;
  background: #fff;
  box-shadow: 0 0 0 3px rgba(64, 170, 132, 0.1);
}
.phone-input::placeholder {
  color: #94a3b8;
}

.phone-submit-btn {
  width: 100%;
  height: 40px;
  margin-top: 12px;
  background: #40aa84;
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  border-radius: 9999px;
  border: none;
  cursor: pointer;
  box-shadow: 0 4px 6px rgba(64, 170, 132, 0.25);
  transition: all 0.3s;
}
.phone-submit-btn:hover {
  filter: brightness(1.1);
  box-shadow: 0 6px 12px rgba(64, 170, 132, 0.3);
}
.phone-submit-btn:active {
  transform: scale(0.98);
}
.phone-submit-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  filter: none;
}
.phone-input--error {
  border-color: #ef4444 !important;
  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1);
}
</style>
